import React, { useMemo, memo } from 'react';
import styled from 'styled-components';
import { focusStyles } from 'src/theme';
import useTranslation from 'hooks/use-translation';
import { useGetCustomCategoryLink } from 'src/dispensary/hooks/use-get-custom-category-link';
import { useHardAgeGate } from 'hooks/use-hard-age-gate';
import { getCategoryPhoto } from 'shared/helpers/dispensaries';

import Link from 'components/core/link';
import CategoryTile from 'shared/components/category-tile';
import { tracker } from 'src/utils/analytics';

function CategoryTileLink({ category, dispensary, ...props }) {
  const href = useGetCustomCategoryLink(category?.customCategory, category?.slug, category?.key);
  const { hardAgeGate, dispensaryLogoImage } = useHardAgeGate();
  const { t } = useTranslation();

  const { translatedLabel, imgSrc } = useMemo(
    () => ({
      translatedLabel: t(`common.${category?.label}`, {
        defaultValue: '{{categoryLabel}}',
        categoryLabel: category?.label,
      }),
      imgSrc: hardAgeGate ? dispensaryLogoImage : getCategoryPhoto(dispensary, category),
    }),
    [t, category, hardAgeGate, dispensaryLogoImage, dispensary]
  );

  return (
    <Link href={href}>
      <StyledAnchor
        onClick={() =>
          tracker.gaGTMClickEvent({
            eventCategory: 'navigation click',
            eventAction: 'category tile',
            eventLabel: category?.label,
          })
        }
        data-testid='category-list-link'
      >
        <CategoryTile imgSrc={imgSrc} label={translatedLabel} {...props} />
      </StyledAnchor>
    </Link>
  );
}
export default memo(CategoryTileLink);

const StyledAnchor = styled.div`
  // apply styles to card on focus
  &.focus-visible {
    outline: none;
    box-shadow: none !important;
    > div {
      ${focusStyles}
    }
  }
`;
